import { getFetchOptions } from "../utils";
export function getCityFiasFromSuggestion(suggestion) {
    var _a, _b;
    const settlementFias = (_a = suggestion.data.settlement_fias_id) !== null && _a !== void 0 ? _a : suggestion.data.city_fias_id;
    return suggestion.data.region === 'Московская' ? (_b = suggestion.data.city_fias_id) !== null && _b !== void 0 ? _b : settlementFias : settlementFias;
}
export function isInsideBeltway(suggestion) {
    var _a;
    return ['IN_MKAD', 'IN_KAD'].includes((_a = suggestion === null || suggestion === void 0 ? void 0 : suggestion.data) === null || _a === void 0 ? void 0 : _a.beltway_hit);
}
export function useDeliveryApi() {
    function getDeliveryInfoFromSuggestion(suggestion, addExtraDay) {
        return getDeliveryInfo(suggestion.data.region, getCityFiasFromSuggestion(suggestion), suggestion.data.postal_code, addExtraDay, isInsideBeltway(suggestion));
    }
    function getAddressInfo(id, addExtraDay = false) {
        return fetch('/api/address_info', getFetchOptions({ id, addExtraDay }, true)).then(response => response.json());
    }
    function getAddressesInfo(addExtraDay = false) {
        return fetch('/api/addresses_info', getFetchOptions({ addExtraDay }, true)).then(response => response.json());
    }
    function getDeliveryInfo(region, fias, zip, addExtraDay, insideBeltway = false) {
        return fetch('/api/delivery_calculator', getFetchOptions({ addExtraDay, region, fias, zip, insideBeltway: !!insideBeltway }))
            .then(response => response.json());
    }
    function getCDEKPointInfo(id) {
        return fetch('/api/cdek/point_info', getFetchOptions({ id }))
            .then(response => response.json());
    }
    return {
        getAddressInfo,
        getAddressesInfo,
        getDeliveryInfo,
        getDeliveryInfoFromSuggestion,
        getCDEKPointInfo,
    };
}
